module.exports = __webpack_public_path__ + "img/login-bg.55fd852b.png";